 
namespace TabAurous.Reports {
    export class LineChartOptions {
        items: TabAurous.Purchase.ApprovalInRow[];
    }

    export class LineChartPanel extends Serenity.TemplatedPanel<LineChartOptions> {
        constructor(container: JQuery, opt: LineChartOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0];
            code.pop();
            grossamount.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                if (data[i].LedgerName != null) {
                    for (var j = 0; j < code.length; j++) {
                        if (data[i].LedgerName.match(code[j])) {
                            checkexists = true;
                            grossamount[j] += parseFloat(data[i].GrossAmount.toFixed(2));
                        }
                    }
                    if (!checkexists) {
                        code.push(data[i].LedgerName);
                        grossamount.push(parseFloat(data[i].GrossAmount.toFixed(2)));
                    }
                }
            }
            var options = {
                chart: {
                    height: 250,
                    width: 430,
                    type: 'line',
                    fontFamily: '"PT Sans", sans-serif',
                    zoom: {
                        enabled: false
                    }
                },
                series: [
                    {
                        name: 'sales',
                        data: grossamount
                    }
                ],

                stroke: {
                    curve: 'straight'
                },
                xaxis: {
                    categories: code
                }
            }
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

}